export const FileIcon = ({ className }: { className?: string }) => (
  <svg className={className} width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.3945 4.875V17.25H3.39453V0.75L11.1088 0.75M15.3945 4.875L11.1088 0.75M15.3945 4.875H11.1088V0.75"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
